import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';

const AnalystPromptBox = ({ promptBox, promptText, setPromptText, submitPrompt, setPromptBox }) => {

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submitPrompt();
    }
  };

  return (
    <div
      className="absolute z-[1000] bg-[#404880] rounded-lg p-3 w-72 text-white shadow-xl border border-white/10"
      style={{
        top: promptBox.y,
        left: promptBox.x,
      }}
    >
      <div className="flex justify-end">
        <CloseIcon
          onClick={() => setPromptBox({ ...promptBox, visible: false })}
          className="cursor-pointer text-white/70 hover:text-white transition-colors"
          style={{ fontSize: '14px' }}
        />
      </div>
      <div className="flex items-end gap-2 mt-1">
        <textarea
          placeholder="Enter your prompt for selected data"
          value={promptText}
          onChange={(e) => setPromptText(e.target.value)}
          onKeyDown={handleKeyDown}
          className="w-full h-24 mt-1 px-3 py-2 rounded bg-white/10 border border-white/20 text-white text-sm placeholder-white/40 resize-none focus:outline-none focus:ring-1 focus:ring-brand-pink/50"
        />
        <button
          onClick={submitPrompt}
          className="flex items-center justify-center bg-brand-pink hover:bg-brand-pink/80 text-white border-none rounded p-2 h-10 cursor-pointer transition-colors"
        >
          <SendIcon style={{ fontSize: '14px' }} />
        </button>
      </div>
    </div>
  );
};

export default AnalystPromptBox;
